/* eslint-disable max-lines-per-function */
import {ParameterValidator} from '@mvps-genesis/utilities';

export default class AddressFields {

	/**
	 * Options:
	 * billAddressDescripInput
	 * billAddressEditElem
	 * billAddressFields
	 * billAddressFieldsElem
	 * billAddressNewElem
	 * billAddressSelect
	 * billAddressSelectedElem
	 * shipAddressDescripInput
	 * shipAddressEditElem
	 * shipAddressFields
	 * shipAddressFieldsElem
	 * shipAddressNewElem
	 * shipAddressSelect
	 * shipAddressSelectedElem
	 */

	constructor ({
		billAddressDescripInput = '#l-BillAddressDescrip',
		billAddressEditElem = '#js-saved-address-edit-billing',
		billAddressFields = '#billing_fields',
		billAddressFieldsElem = '#js-billing-fields',
		billAddressNewElem = '#js-new-address-billing',
		billAddressSelect = '#billing_selector',
		billAddressSelectedElem = '#js-billing-address-selected',
		shipAddressDescripInput = '#l-ShipAddressDescrip',
		shipAddressEditElem = '#js-saved-address-edit-shipping',
		shipAddressFields = '#shipping_fields',
		shipAddressFieldsElem = '#js-shipping-fields',
		shipAddressNewElem = '#js-new-address-shipping',
		shipAddressSelect = '#shipping_selector',
		shipAddressSelectedElem = '#js-shipping-address-selected'
	} = {}) {

		// Create validator
		this.validator = new ParameterValidator(this);

		this.elements = {
			billAddressDescripInput: this.validator.isElement('billAddressDescripInput', billAddressDescripInput),
			billAddressEditElem: this.validator.isElement('billAddressEditElem', billAddressEditElem, {required: false}),
			billAddressFields: this.validator.isElement('billAddressFields', billAddressFields),
			billAddressFieldsElem: this.validator.isElement('options.billAddressFieldsElem', billAddressFieldsElem),
			billAddressNewElem: this.validator.isElement('billAddressNewElem', billAddressNewElem, {required: false}),
			billAddressSelect: this.validator.isElement('billAddressSelect', billAddressSelect),
			billAddressSelectedElem: this.validator.isElement('billAddressSelectedElem', billAddressSelectedElem),
			shipAddressDescripInput: this.validator.isElement('shipAddressDescripInput', shipAddressDescripInput),
			shipAddressEditElem: this.validator.isElement('shipAddressEditElem', shipAddressEditElem, {required: false}),
			shipAddressFields: this.validator.isElement('shipAddressFields', shipAddressFields),
			shipAddressFieldsElem: this.validator.isElement('shipAddressFieldsElem', shipAddressFieldsElem),
			shipAddressNewElem: this.validator.isElement('shipAddressNewElem', shipAddressNewElem, {required: false}),
			shipAddressSelect: this.validator.isElement('shipAddressSelect', shipAddressSelect),
			shipAddressSelectedElem: this.validator.isElement('shipAddressSelectedElem', shipAddressSelectedElem)
		};

		this.bindEvents();

		this.lastBillAddressID = '';
		this.lastShipAddressID = '';
	}

	bindEvents () {
		this.elements.billAddressSelect.addEventListener('change', () => this.addressChanged('billing'), false);
		this.elements.shipAddressSelect.addEventListener('change', () => this.addressChanged('shipping'), false);

		if (this.elements.billAddressEditElem) {
			this.elements.billAddressEditElem.addEventListener('click', (e) => this.editAddress(e, 'billing'), false);
		}

		if (this.elements.shipAddressEditElem) {
			this.elements.shipAddressEditElem.addEventListener('click', (e) => this.editAddress(e, 'shipping'), false);
		}

		if (this.elements.billAddressNewElem) {
			this.elements.billAddressNewElem.addEventListener('click', (e) => this.newAddress(e, 'billing'), false);
		}

		if (this.elements.shipAddressNewElem) {
			this.elements.shipAddressNewElem.addEventListener('click', (e) => this.newAddress(e, 'shipping'), false);
		}
	}

	addressChanged (address_type) {
		const select = address_type === 'billing' ? this.elements.billAddressSelect : this.elements.shipAddressSelect;
		const selectedAddress = window.MvCustomerAddresses[select.value];

		this.updateAddress(address_type, selectedAddress);
	}

	updateAddress (address_type, selectedAddress) {
		const selectedElem = address_type === 'billing' ? this.elements.billAddressSelectedElem : this.elements.shipAddressSelectedElem;
		const fields = address_type === 'billing' ? this.elements.billAddressFields : this.elements.shipAddressFields;
		const editElem = address_type === 'billing' ? this.elements.billAddressEditElem : this.elements.shipAddressEditElem;
		const fieldsElem = address_type === 'billing' ? this.elements.billAddressFieldsElem : this.elements.shipAddressFieldsElem;
		const descripInput = address_type === 'billing' ? this.elements.billAddressDescripInput : this.elements.shipAddressDescripInput;

		if (selectedAddress) {
			descripInput.value = selectedAddress.descrip;
			selectedElem.innerHTML = `
				<div class="u-text-medium">${selectedAddress.lname}</div>
				<div>${selectedAddress.addr1}${selectedAddress.addr2 ? ' ' + selectedAddress.addr2 : ''}</div>
				<div>${selectedAddress.city} ${selectedAddress.state} ${selectedAddress.zip} ${selectedAddress.cntry}</div>
			`;

			selectedElem.classList.remove('u-hidden');

			if (editElem) {
				editElem.style.display = '';
			}

			if (this.elements.shipAddressEditElem) {
				if (selectedAddress.editable === 1) {
					this.elements.shipAddressEditElem.style.display = '';
				} else {
					this.elements.shipAddressEditElem.style.display = 'none';
					this.elements.shipAddressFieldsElem.style.display = 'none';
				}

			}

			fields.classList.remove('new-address--selected');
		} else {
			descripInput.value = '';
			selectedElem.innerHTML = `
				<div class="u-text-medium">&nbsp;</div>
				<div>&nbsp;</div>
				<div>&nbsp;</div>
			`;

			selectedElem.classList.add('u-hidden');

			if (editElem) {
				editElem.style.display = 'none';
			}

			if (fields.classList.contains('new-address--selected')) {
				fields.classList.remove('new-address--selected');
			} else {
				fields.classList.add('new-address--selected');
			}

			if (window.getComputedStyle(fieldsElem).display === 'none' && fields.classList.contains('new-address--selected')) {
				this.constructor.slideDown(fieldsElem);
			}
		}
	}

	newAddress (e, address_type) {
		if (e) {
			e.preventDefault();
		}

		const select = address_type === 'billing' ? this.elements.billAddressSelect : this.elements.shipAddressSelect;
		const fields = address_type === 'billing' ? this.elements.billAddressFields : this.elements.shipAddressFields;
		const fieldsElem = address_type === 'billing' ? this.elements.billAddressFieldsElem : this.elements.shipAddressFieldsElem;
		if (select.value !== '-1') {
			if (address_type === 'billing') {
				this.lastBillAddressID = select.value;
			} else {
				this.lastShipAddressID = select.value;
			}

			select.value = '-1';
		}

		this.constructor.triggerChange(select);

		if (window.getComputedStyle(fieldsElem).display === 'none' && fields.classList.contains('new-address--selected')) {
			this.constructor.slideDown(fieldsElem);
		} else if (!fields.classList.contains('new-address--selected')) {
			this.constructor.slideUp(fieldsElem);

			if (address_type === 'billing' && this.lastBillAddressID) {
				select.value = this.lastBillAddressID;
				this.constructor.triggerChange(select);
			} else if (address_type === 'shipping' && this.lastShipAddressID) {
				select.value = this.lastShipAddressID;
				this.constructor.triggerChange(select);
			}
		}
	}

	editAddress (e, address_type) {
		e.preventDefault();

		const fields = address_type === 'billing' ? this.elements.billAddressFieldsElem : this.elements.shipAddressFieldsElem;

		this.slideToggle(fields);
	}

	static triggerChange (elem) {
		if ('createEvent' in document) {
			var evt = document.createEvent('HTMLEvents');
			evt.initEvent('change', false, true);
			elem.dispatchEvent(evt);
		} else {
			elem.fireEvent('onchange');
		}
	}

	static slideDown (target, duration = 500) {
		target.style.removeProperty('display');
		let display = window.getComputedStyle(target).display;

		if (display === 'none') {
			display = 'block';
		}

		target.style.display = display;
		let height = target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		// eslint-disable-next-line no-unused-expressions
		target.offsetHeight;
		target.style.boxSizing = 'border-box';
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.height = height + 'px';
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		setTimeout(() => {
			target.style.removeProperty('height');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
		}, duration);
	}

	static slideUp (target, duration = 500) {
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.boxSizing = 'border-box';
		target.style.height = target.offsetHeight + 'px';
		// eslint-disable-next-line no-unused-expressions
		target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		window.setTimeout(() => {
			target.style.display = 'none';
			target.style.removeProperty('height');
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
		}, duration);
	}

	slideToggle (target, duration = 500) {
		if (window.getComputedStyle(target).display === 'none') {
			return this.constructor.slideDown(target, duration);
		}

		return this.constructor.slideUp(target, duration);
	}
}
